import React from 'react';
import {SectionContainer, SectionTitle} from './helpers';
import {useAgentBuilderStore} from '../AgentBuilder.state';
import {AccountSelectionOptions} from '../AccountSelectionOptions';
import {FormControl, RequiredIndicator, HStack} from '@chakra-ui/react';

export const AccountSelectionSection = () => {
  const {accountFilter, setAccountFilter} = useAgentBuilderStore();

  return (
    <FormControl isRequired>
      <SectionContainer>
        <HStack gap="0">
          <SectionTitle>Select Accounts to Run</SectionTitle>
          <RequiredIndicator />
        </HStack>
        <AccountSelectionOptions
          accountFilter={accountFilter}
          onAccountFilterChange={setAccountFilter}
        />
      </SectionContainer>
    </FormControl>
  );
};
